/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTYuNSw4LjVILjVWLjVoNlptLTUtMWg0di02aC00WiIvPjxwYXRoIGQ9Ik02LjUsMTUuNUguNXYtNWg2Wm0tNS0xaDR2LTNoLTRaIi8+PHBhdGggZD0iTTE1LjQsMTUuNUg5LjV2LThoNS45Wm0tNC45LTFoMy45di02SDEwLjVaIi8+PHBhdGggZD0iTTE1LjQsNS41SDkuNVYuNWg1LjlabS00LjktMWgzLjl2LTNIMTAuNVoiLz48L3N2Zz4=";